import React from 'react';
import { Box, Icon, useFirebaseContext } from '@medely/ui-kit';

const ApplicationHeaderLogout = ({ isMobile }: { isMobile: boolean }): React.ReactElement => {
  const { logout } = useFirebaseContext();

  return (
    <Box onClick={() => logout?.()} aria-label="Log out" testId="application-logout" pl={2}>
      <Icon
        name="right-from-bracket"
        iconSize={isMobile ? '15px' : '20px'}
        variant="custom"
        color="text.secondary"
      />
    </Box>
  );
};

export default ApplicationHeaderLogout;
